import { SuccessfulTransactionGeneralInfo } from "Components/Transactions/Anonymous/SuccessfulTransactionInfo/SuccessfulTransactionGeneralInfo";
import { SuccessfulTransactionCampaignInfo } from "Components/Transactions/Anonymous/SuccessfulTransactionInfo/SuccessfulTransactionCampaignInfo";
import { useCampaignData } from "Hooks/useCampaignData";

type Props = {
  transactionPublicID: string;
};

export const SuccessfulTransactionInfo = ({ transactionPublicID }: Props) => {
  const campaignCode = useCampaignData(transactionPublicID);

  if (campaignCode) {
    return <SuccessfulTransactionCampaignInfo campaignCode={campaignCode} />;
  }

  return (
    <SuccessfulTransactionGeneralInfo
      transactionPublicID={transactionPublicID}
    />
  );
};
